import React, { useState, useEffect } from 'react';

const fmtWhen = (d) => d ? new Date(d).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '';
const LABEL = { done: 'Terminée', skipped: 'Passée' };

/** Carte d'une étape action en exécution (le badge de statut est rendu par la timeline). */
export default function WorkflowExecutionStep({ node, state, busy, readOnly, onMutate, onSetNote, onSetCondition }) {
  const status = state?.status || 'todo';
  const [noteDraft, setNoteDraft] = useState(state?.note || '');
  const [noteOpen, setNoteOpen] = useState(false);
  useEffect(() => { setNoteDraft(state?.note || ''); }, [state?.note]);

  const conditionRequired = !!node.completion_condition;
  const conditionOk = !conditionRequired || !!state?.condition_checked;
  const disabled = busy || readOnly;
  const saveNote = () => { if (noteDraft !== (state?.note || '')) onSetNote(noteDraft); setNoteOpen(false); };

  const chips = [];
  if (node.automatable) chips.push('🤖 auto');
  if (node.responsible) chips.push(`👤 ${node.responsible}`);
  if (node.estimated_minutes) chips.push(`⏱ ${node.estimated_minutes} min`);

  const cls = `wf-card ${status === 'in_progress' ? 'current' : ''} ${status === 'done' ? 'done' : ''} ${status === 'skipped' ? 'skipped' : ''}`;

  return (
    <div className={cls}>
      <div className="wf-card-head">
        <span className="wf-card-title">{node.title || 'Étape sans titre'}</span>
      </div>

      {(chips.length > 0 || node.link?.value) && (
        <div className="wf-meta">
          {chips.map((c, i) => <span key={i} className="wf-chip">{c}</span>)}
          {node.link?.value && (node.link.kind === 'url'
            ? <a className="wf-chip wf-chip-link" href={node.link.value} target="_blank" rel="noreferrer">🔗 lien</a>
            : <span className="wf-chip" title={node.link.value}>🔗 {node.link.value}</span>)}
        </div>
      )}
      {node.description && <p className="wf-step-desc">{node.description}</p>}

      {conditionRequired && (
        <label className={`wf-cond ${conditionOk ? 'ok' : ''}`}>
          <input type="checkbox" checked={!!state?.condition_checked} disabled={disabled} onChange={(e) => onSetCondition(e.target.checked)} />
          {node.completion_condition}
        </label>
      )}

      {(status === 'done' || status === 'skipped') && state?.completed_by_name && (
        <div className="wf-step-by">{LABEL[status]} · {state.completed_by_name} · {fmtWhen(state.completed_at)}</div>
      )}

      {noteOpen ? (
        <div className="wf-note-edit">
          <textarea rows={2} value={noteDraft} placeholder="Note…" autoFocus onChange={(e) => setNoteDraft(e.target.value)} />
          <div className="wf-note-actions">
            <button className="wf-act-ghost" onClick={() => { setNoteDraft(state?.note || ''); setNoteOpen(false); }}>Annuler</button>
            <button className="wf-act primary" onClick={saveNote} disabled={disabled}>Enregistrer</button>
          </div>
        </div>
      ) : state?.note ? (
        <span className="wf-note-line" onClick={() => !readOnly && setNoteOpen(true)}>📝 {state.note}</span>
      ) : null}

      {!readOnly && (
        <div className="wf-card-foot">
          {status === 'todo' && <button className="wf-act primary" disabled={disabled} onClick={() => onMutate('start')}>Démarrer</button>}
          {status === 'in_progress' && <>
            <button className="wf-act primary" disabled={disabled || !conditionOk} title={!conditionOk ? 'Cochez la condition' : ''} onClick={() => onMutate('complete')}>Terminer</button>
            <button className="wf-act" disabled={disabled} onClick={() => onMutate('skip')}>Passer</button>
          </>}
          {(status === 'done' || status === 'skipped') && <button className="wf-act-ghost" disabled={disabled} onClick={() => onMutate('reopen')}>Réouvrir</button>}
          {!noteOpen && status !== 'done' && status !== 'skipped' && (
            <button className="wf-act-ghost" title="Note" disabled={disabled} onClick={() => setNoteOpen(true)}>📝 Note</button>
          )}
        </div>
      )}
    </div>
  );
}
